import { FilterConFig } from '../../utils/FilterConfig';
import type { StatusModel } from '../../api/vegApl';
import { getSplotStatusIdsByTab } from '../../utils/statusUtils';

const SPLOT_FILTER_URL = FilterConFig['splot']['searchFilter'];

const EMPTY_FILTER_BASE = {
    splot_id: '',
    crop_code: [],
    status_id: [] as number[],
    material_id: '',
    site_code: [] as string[],
    priority: [] as string[],
    from_date: '',
    to_date: '',
    trial_id: '',
    is_archive: false,
};

/**
 * Builds the filter request payload for the SPLot search API
 * based on the selected accessible filter tab.
 */
export const buildSPLotFilterRequest = (
    selectedFilter: string,
    is_archive:boolean,
    siteCode?: string,
    splotStatuses: StatusModel[] = [],
) => {
    const siteCodes = siteCode ? [siteCode] : [];

    if (selectedFilter === 'High priority MatIDs') {
        return {
            data: { ...EMPTY_FILTER_BASE, site_code: siteCodes, priority: ['High'],is_archive:is_archive },
            url: SPLOT_FILTER_URL,
        };
    }

    const statusValue = getSplotStatusIdsByTab(selectedFilter, splotStatuses);

    return {
        data: { ...EMPTY_FILTER_BASE, site_code: siteCodes, status_id: statusValue, is_archive: is_archive },
        url: SPLOT_FILTER_URL,
    };
};

/**
 * Re-applies an existing active filter with the updated site code.
 */
export const reApplyFilterWithSite = (activeFilter: any, siteCode: string,is_archive:boolean) => ({
    data: { ...activeFilter, site_code: siteCode ? [siteCode] : [],is_archive:is_archive },
    url: SPLOT_FILTER_URL,
});
